import React from 'react';
import { Link, Outlet } from 'react-router-dom'
import './uganda_p6math.css'

import Uganda_p6 from './uganda_p6';

import Uganda_p6_subjects from './uganda_p6_subjects';
import Card6math_topics from '../../components/card6math_topics';
import Uganda_p6math_competences from './uganda_p6math_competences';
import LowerNavbar from '../../learning/california/california_classes';
import Uganda_p6math_topics from './uganda_p6math_topics';

const Uganda_p6math = () => {

  return (
    <>
    
<Uganda_p6 />
<Uganda_p6_subjects />

        <div className='fixed right-0 left-0 top-37  '>  
<div className="card-container z-50">
      <div className="card-header">
        
      </div>
      <div className="card-body-columns">
        <div className="column-item">
         <section className='flex '> 
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_complement_of_sets" className=''>1. Form complement of a set</Link>
    </section>
      <section>
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_equal_sets" className=''>2. Form equal sets</Link>
    </section>
      <section>
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_subsets" className=''>3. Form subsets</Link> 
    </section>
        </div>
        <div className="column-item">
          <section className='flex '> 
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_complement_of_sets" className=''>1. Form complement of a set</Link>
    </section>
      <section>
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_equal_sets" className=''>2. Form equal sets</Link>
    </section>
      <section>
    <Link to="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_subsets" className=''>3. Form subsets</Link> 
    </section>
        </div>
        <div className="column-item">
          <h3>Column 3</h3>
          <p>This is the content for the third column. It completes the card's data.</p>
        </div>
      </div>
      <div className="card-footer">
        <p>Card Footer Information</p>
      </div>
    </div>
    </div>

    
    </>
  );
}

export default Uganda_p6math;